import SecurityPinScreen from './SecurityPinScreen';

export { SecurityPinScreen };

export default SecurityPinScreen;
